import React from "react";
import "./index.scss";
import * as _ from "lodash";

const Popup = ({ config, children }) => {
  const title = _.get(config, "title");
  const isOpen = _.get(config, "isOpen");
  const onClose = _.get(config, "onClose", () => {});
  const position = _.get(config, "position");
  const style = _.get(config, "style", {});
  const className = _.get(config, "className", "");
  const isBackground = _.get(config, "isBackground", false);

  if (!isOpen) return null;

  return (
    <div
      className="popup-backdrop"
      style={isBackground ? { backgroundColor: "rgba(0, 0, 0, 0.5)" } : {}}
      onClick={(e) => {
        if (e.target.classList.contains("popup-backdrop")) {
          onClose();
        }
      }}
    >
      <div
        className={`${className} popup-content`}
        style={
          position
            ? {
                position: "absolute",
                top: position.top,
                left: position.left,
                zIndex: 1050,
                ...style,
              }
            : style
        }
      >
        {title && (
          <div className="popup-header">
            <h3>{title}</h3>
            <button onClick={onClose} className="popup-close">
              <img src="/img/chat/icon/x.svg" alt="" />
            </button>
          </div>
        )}
        <br></br>
        <div className="popup-body">{children}</div>
      </div>
    </div>
  );
};

export default Popup;
